import { createMemoStyles } from '@wds/utils';
import { HeaderTheme } from '../../theme';

type NotificationItemStyleProps = {
  read?: boolean;
};

const useStyles = createMemoStyles(({ spacing, palette }: HeaderTheme) => ({
  notificationsItem: ({ read }: NotificationItemStyleProps) => ({
    padding: [spacing[4], spacing[4], spacing[4], 40],
    borderBottom: [1, 'solid', palette.border.muted],
    position: 'relative',

    ...(!read && {
      '&:before': {
        position: 'absolute',
        height: 8,
        width: 8,
        borderRadius: '50%',
        backgroundColor: palette.error.main,
        content: '""',
        top: '50%',
        left: spacing[4],
      },
      '&:hover': {
        backgroundColor: palette.background.accent,
      },
    }),
  }),
}));

export default useStyles;
